(() => {
  'use strict';
  const video = document.querySelector('#gavin-video');
  if (!video) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false, unavailable = false, pending = false;
  video.muted = true;
  function loadVideo() {
    if (video.hasAttribute('src')) return;
    video.src = innerWidth <= 760 ? video.dataset.mobileSrc : video.dataset.desktopSrc;
    video.load();
  }
  function canPlay() {
    return visible && !document.hidden && !document.body.classList.contains('modal-open') && !unavailable && !reduced.matches;
  }
  function sync() {
    if (!canPlay()) {video.pause(); return;}
    loadVideo();
    if (pending || !video.paused) return;
    pending = true;
    let interrupted = false;
    video.play().catch(error => {
      if (error.name === 'AbortError') interrupted = true;
      else unavailable = true; // Autoplay restrictions retain the supplied poster.
    }).finally(() => {
      pending = false;
      if (!canPlay()) video.pause();
      if (interrupted && canPlay()) sync();
    });
  }
  new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && !reduced.matches) loadVideo();
  },{rootMargin:'250px'}).observe(video);
  new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
    sync();
  },{threshold:[0,.2]}).observe(video);
  reduced.addEventListener('change',sync);
  document.addEventListener('visibilitychange',sync);
  new MutationObserver(sync).observe(document.body,{attributes:true,attributeFilter:['class']});
  video.addEventListener('error',() => {unavailable = true; video.pause();});
})();
